import React from 'react';
import { observer } from 'mobx-react';
import { NikoFacilityListTemplate } from 'themes/application/niko-facility/pages';
import { setCurrentView } from 'core/utils';
import { NikoFacilityListViewStore } from 'application/niko-facility/stores';

@setCurrentView((rootStore) => new NikoFacilityListViewStore(rootStore), 'nikoFacilityListViewStore')
@observer
class NikoFacilityList extends React.Component {
    render() {
        return <NikoFacilityListTemplate {...this.props} />
    }
}

export default NikoFacilityList;